import { useState, useEffect } from 'react';
import { EqCondition, useFilterContext, BaseFilterProps, Filter } from 'framework/list';
import { FilterCondition } from 'framework/types';
import { InputLoader } from 'framework/ui/mui-builder';
import ProjectInput from '../input/ProjectInput';
import useNewProjectService from '../newProjectService';
import { ProjectSearchDto } from '../types';

interface ProjectFilterProps extends BaseFilterProps {
  label?: string;
  isByLegacyId?: boolean;
}

const setProjectLabel = (searchSuggestions: any, projectId: string, setLabel: any, setProjectIdLoaded: any) => {
  (async () => {
    const response = await searchSuggestions({
      filter: {
        legacyId: {
          eq: projectId,
        },
      },
    });
    const procject = response && response.result && !!response.result.length && response.result[0];
    setLabel(procject.name);
    setProjectIdLoaded(true);
  })();
};

// Filter by useNewProjectService
const ProjectFilter = ({ label: filterLabel, source, isByLegacyId = false, ...props }: ProjectFilterProps) => {
  const { filterBy, getValue } = useFilterContext();
  const { search } = useNewProjectService();

  const [label, setLabel] = useState('');
  const [projectIdLoaded, setProjectIdLoaded] = useState(false);

  useEffect(() => {
    const projectId = getValue(source, FilterCondition.EQ);

    if (projectId) {
      setProjectLabel(search, projectId, setLabel, setProjectIdLoaded);
    } else {
      setProjectIdLoaded(true);
    }
    // Suppressed warnings because we only need to call useEffect callback ones after the first mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChangeCallback = (filter: Filter) => {
    filterBy(filter);
  };

  return projectIdLoaded ? (
    <EqCondition {...props} source={source} onChangeCallback={onChangeCallback}>
      <ProjectInput
        mapResults={(item: ProjectSearchDto) => ({
          id: isByLegacyId ? item.legacyId : item.id,
          text: item.name,
        })}
        initialLabel={label}
        source={source}
        label={filterLabel}
        searchString="name"
      />
    </EqCondition>
  ) : (
    <InputLoader />
  );
};

export default ProjectFilter;
